var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCleaningStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 480 480.005",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#65c2c9",
    d: "M304.004 40.004h32c8.836 0 16 7.164 16 16v16c0 8.836-7.164 16-16 16h-32c-8.84 0-16-7.164-16-16v-16c0-8.836 7.16-16 16-16zm0 0",
    opacity: 1,
    "data-original": "#65c2c9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc933",
    d: "M40.004 168.004h-32v-24l32-8zm0 0",
    opacity: 1,
    "data-original": "#ffc933"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34a2bf",
    d: "M72.004 216.004h128v96h-128zm0 0",
    opacity: 1,
    "data-original": "#34a2bf"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#65c2c9",
    d: "M472.004 360.004c-154.664-55.422-309.336 55.426-464 0v112h464zm0 0",
    opacity: 1,
    "data-original": "#65c2c9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34a2bf",
    d: "M472.004 392.004c-154.664-55.422-309.336 55.426-464 0v80h464zm0 0",
    opacity: 1,
    "data-original": "#34a2bf"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2a8aa0",
    d: "M472.004 424.004c-154.664-55.422-309.336 55.426-464 0v48h464zm0 0",
    opacity: 1,
    "data-original": "#2a8aa0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e38100",
    d: "M176.004 168.004v-160l-48 16v144zm0 0",
    opacity: 1,
    "data-original": "#e38100"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc933",
    d: "m128.004 104.004-48-16v80h48zm0 0",
    opacity: 1,
    "data-original": "#ffc933"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34a2bf",
    d: "M136.004 248.004h64v32h-64zm0 0",
    opacity: 1,
    "data-original": "#34a2bf"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6c6c1",
    d: "M232.004 296.004c0 8.8 21.488 16 48 16s48-7.2 48-16v-80h-96zm0 0",
    opacity: 1,
    "data-original": "#c6c6c1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2af",
    d: "M232.004 296.004c0 8.8 21.488 16 48 16s48-7.2 48-16v-64c-16.149 38.758-54.016 64-96 64zm0 0",
    opacity: 1,
    "data-original": "#b2b2af"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34a2bf",
    d: "M328.004 216.004c0-8.836-21.492-16-48-16-26.512 0-48 7.164-48 16s21.488 16 48 16c26.508 0 48-7.164 48-16zm0 0",
    opacity: 1,
    "data-original": "#34a2bf"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2a8aa0",
    d: "M248.004 224.004c0-8.84 21.488-16 48-16a119.275 119.275 0 0 1 30.07 3.535c-5.8-6.664-24.215-11.535-46.07-11.535-26.512 0-48 7.16-48 16 0 5.039 7.008 9.527 17.926 12.465a6.857 6.857 0 0 1-1.926-4.465zm0 0",
    opacity: 1,
    "data-original": "#2a8aa0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afaab0",
    d: "M472.004 296.004c0 8.8-25.074 16-56 16-30.93 0-56-7.2-56-16v-48h112zm0 0",
    opacity: 1,
    "data-original": "#afaab0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#989399",
    d: "M360.004 296.004c0 8.8 25.07 16 56 16 30.926 0 56-7.2 56-16v-34.281a199.099 199.099 0 0 1-112 34.28zm0 0",
    opacity: 1,
    "data-original": "#989399"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#65c2c9",
    d: "M472.004 248.004c0-8.836-25.074-16-56-16-30.93 0-56 7.164-56 16s25.07 16 56 16c30.926 0 56-7.164 56-16zm0 0",
    opacity: 1,
    "data-original": "#65c2c9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50a8aa",
    d: "M376.004 256.004c0-8.8 25.07-16 56-16a152.816 152.816 0 0 1 38.535 4.41c-5.738-7.105-27.937-12.41-54.535-12.41-30.93 0-56 7.16-56 16 0 4.57 6.726 8.672 17.46 11.594a5.78 5.78 0 0 1-1.46-3.594zM296.938 86.293a15.866 15.866 0 0 0 7.066 1.71h32c8.836 0 16-7.163 16-16v-16c0-.19-.05-.374-.059-.565a95.656 95.656 0 0 1-55.008 30.855zm0 0",
    opacity: 1,
    "data-original": "#50a8aa"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34a2bf",
    d: "M72.004 216.004h64v32h-64zM72.004 280.004h64v32h-64zm0 0",
    opacity: 1,
    "data-original": "#34a2bf"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc933",
    d: "m200.004 96.004-24 24v48h48v-48zm0 0",
    opacity: 1,
    "data-original": "#ffc933"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dda722",
    d: "M176.004 160.004v8h48v-48l-.625-.625c-3.633 23.363-23.734 40.598-47.375 40.625zm0 0",
    opacity: 1,
    "data-original": "#dda722"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c16900",
    d: "M128.004 160.004v8h48v-48l-.625-.625c-3.633 23.363-23.734 40.598-47.375 40.625zm0 0",
    opacity: 1,
    "data-original": "#c16900"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dda722",
    d: "M80.004 160.004v8h48v-48l-.625-.625c-3.633 23.363-23.734 40.598-47.375 40.625zm0 0",
    opacity: 1,
    "data-original": "#dda722"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e38100",
    d: "M40.004 120.004h40v48h-40zm0 0",
    opacity: 1,
    "data-original": "#e38100"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c16900",
    d: "M40.004 160.004v8h40v-48c0 22.094-17.91 40-40 40zm0 0",
    opacity: 1,
    "data-original": "#c16900"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dda722",
    d: "M8.004 160.004v8h32v-32l-1.227.305c-3.715 13.949-16.336 23.668-30.773 23.695zm0 0",
    opacity: 1,
    "data-original": "#dda722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.004 224.203v-40.2c0-13.253-10.746-24-24-24-4.422 0-8-3.581-8-8v-128c0-13.253-10.746-24-24-24h-32c-13.258 0-24 10.747-24 24v8h-8c-13.258 0-24 10.747-24 24h-8c-13.258 0-24 10.747-24 24v56a8 8 0 0 1-8 8h-8v-24a8.017 8.017 0 0 0-2.344-5.655l-24-24c-3.125-3.121-8.191-3.121-11.312 0l-10.344 10.343V8.004a8.012 8.012 0 0 0-3.32-6.496A7.929 7.929 0 0 0 173.48.422l-48 16a7.995 7.995 0 0 0-5.476 7.582V92.91L82.53 80.422a7.99 7.99 0 0 0-7.203 1.098 7.994 7.994 0 0 0-3.324 6.484v24h-32c-4.422 0-8 3.582-8 8v9.762l-25.938 6.48a7.993 7.993 0 0 0-6.062 7.758v24c0 4.418 3.578 8 8 8h216a8 8 0 0 0 8-8v-8h8c13.254 0 24-10.746 24-24v-56c0-4.418 3.578-8 8-8h8v104h16v-40h16v40h16v-40h16v40h16v-120c0-13.254-10.746-24-24-24h-8v-8c0-4.418 3.578-8 8-8h32a8 8 0 0 1 8 8v128c0 13.254 10.742 24 24 24a8 8 0 0 1 8 8v40.2c-17.602.8-56 4.714-56 23.8v8h-16v-40c0-16.574-28.129-24-56-24-27.875 0-56 7.426-56 24v40h-16v-40a8 8 0 0 0-8-8h-128c-4.422 0-8 3.582-8 8v40h-8c-13.258 0-24 10.746-24 24v78.96c-7.098-1.862-14.195-3.944-21.305-6.487a7.998 7.998 0 0 0-10.695 7.527v112c0 4.418 3.578 8 8 8h464a8 8 0 0 0 8-8v-112a8.004 8.004 0 0 0-5.305-7.527c-79.32-28.418-159.015-14.153-236.113-.344-65.473 11.734-127.918 22.832-190.582 10.52v-82.65c0-4.417 3.578-8 8-8h8v40c0 4.419 3.578 8 8 8h128a8 8 0 0 0 8-8v-40h16v24c0 16.579 28.125 24 56 24 27.871 0 56-7.421 56-24v-24h16v24c0 23.329 57.453 24 64 24 6.543 0 64-.671 64-24v-48c0-19.085-38.402-23-56-23.8zm-408-73.95 16-4v13.75h-16zm32-14.25v-8h24v32h-24zm40-16V99.11l32 10.664v50.23h-32zm48-16v-74.23l32-10.664v140.895h-32zm80 56h-32v-36.687l16-16 16 16zm80-40V94.532a23.678 23.678 0 0 0 8 1.473h8v24zm32 0v-24h8a23.714 23.714 0 0 0 8-1.472v25.473zm16-64v16a8 8 0 0 1-8 8h-32c-4.422 0-8-3.581-8-8v-16c0-4.417 3.578-8 8-8h32a8 8 0 0 1 8 8zm-312 319.505v15.457a255.064 255.064 0 0 1-16-4.762v-15.086c5.336 1.688 10.664 3.086 16 4.39zm432 37.488c-75.785-23.566-151.785-10.055-225.418 3.137-76.602 13.726-149.07 26.601-222.582 2.07v-15.086c75.781 23.559 151.781 9.953 225.414-3.242 76.61-13.719 149.082-26.703 222.586-2.176zm-448 51.008V435.07a300.587 300.587 0 0 0 90.07 12.887 771.623 771.623 0 0 0 135.344-16.082c76.61-13.719 149.082-26.582 222.586-2.07v34.199zm225.414-96.129c76.61-13.719 149.082-26.703 222.586-2.176v15.297c-75.785-23.558-151.785-10.055-225.418 3.137-65.473 11.734-127.918 22.832-190.582 10.52v-15.77c65.125 11.898 130.14.32 193.414-11.008zm-97.414-111.871h48v16h-48zm-16 16h-48v-16h48zm64-32h-48v-16h48zm-64-16v16h-48v-16zm-48 64h48v16h-48zm64 16v-16h48v16zm136-96c22.11 0 35.512 5.039 39.27 8-3.758 2.96-17.16 8-39.27 8-22.113 0-35.512-5.04-39.274-8 3.762-2.961 17.16-8 39.274-8zm0 96c-23.914 0-37.649-5.895-40-8.68v-61.719a111.528 111.528 0 0 0 40 6.399 111.555 111.555 0 0 0 40-6.399v61.743c-2.356 2.761-16.09 8.656-40 8.656zm136-64a104.28 104.28 0 0 1 46.629 8 104.227 104.227 0 0 1-46.63 8 104.244 104.244 0 0 1-46.632-8 104.298 104.298 0 0 1 46.633-8zm0 64c-27.824 0-44.64-5.742-48-9.024v-30.113a164.987 164.987 0 0 0 96 0v30.113c-3.363 3.282-20.176 9.024-48 9.024zm0 0",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaningStation);
export default __webpack_public_path__ + "static/media/cleaningStation.0c45e417839c2e342735667b490cf9a6.svg";
export { ForwardRef as ReactComponent };